import { DataType } from 'components/table/types';
import { DashboardCategories, currenciesToDisplay } from 'constants/balance.constants';
import _ from 'lodash';

export type tableColumns = Record<DashboardCategories, Record<string, DataType>>;
const commonColumns: Record<string, DataType> = {
	createdAt: 'date',
	reference: 'string',
	createdBy: 'string',
	contactHebrewName: 'string',
};
export const createTableColumns = (currencies: any, data: any): tableColumns => {
	const getAllowedCurrencies = () => {
		if (data) {
			const list = {};
			let uniqueCurrencies: string[] = [];
			data.forEach((company: any) => {
				const ba = company?.balances || [];
				uniqueCurrencies = [...uniqueCurrencies, ..._.keys(_.keyBy(ba, 'currencyCode'))];
			});
			uniqueCurrencies = _.uniq(uniqueCurrencies);
			const firstList = _.intersection(currenciesToDisplay, uniqueCurrencies);
			const secondaryList = _.filter(uniqueCurrencies, (c) => !firstList.includes(c));
			const lst = [...firstList, ...secondaryList];
			lst.forEach((currency) => {
				_.assign(list, { [currency]: 'custom' });
			});
			return list;
		}
		return {};
	};

	return {
		[DashboardCategories.CUSTOMER_BALANCES]: {
			currencyName: 'custom',
			totalSum: 'custom',
			totalInShekel: 'custom',
			rate: 'string',
			accountsAmount: 'string',
		},
		[DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS]: {
			customerName: 'custom',
			hyper: 'string',
			ccId: 'string',
			...getAllowedCurrencies(),
		},
		[DashboardCategories.PENDING_BALANCE]: {
			currencyName: 'custom',
			pendingSum: 'custom',
			totalInShekel: 'custom',
			rate: 'string',
			accountsAmount: 'string',
			/*balancePending: 'custom',
			convertPending: 'custom',*/
		},
		[DashboardCategories.CONVERSION_FEES]: {
			conversionDate: 'date',
			customerName: 'string',
			dealType: 'custom',
			ccBuyAmount: 'custom',
			ccSellAmount: 'custom',
			fee: 'integer',
			currencyName: 'custom',
			totalInShekel: 'custom',
		},
		[DashboardCategories.MONTHLY_SUBSCRIPTIONS]: {
			plan: 'custom',
			totalAccounts: 'integer',
			planAmount: 'custom',
			totalRevenue: 'custom',
		},
		[DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS]: {
			createdAt: 'date',
			customerName: 'string',
			totalBeneficiaries: 'integer',
			paymentDealCount: 'integer',
			conversionDealCount: 'integer',
			totalFees: 'custom',
		},
		[DashboardCategories.PAYMENT_FEES]: {
			dueDate: 'date',
			customerName: 'string',
			paymentAmount: 'custom',
			currencyName: 'custom',
			feeAmount: 'custom',
			feeInShekel: 'custom',
			beneficiaryCompanyName: 'string',
			countryId: 'custom',
			bankAccountCountryId: 'custom',
			//wcHebrewStatus: 'string',
		},

		[DashboardCategories.TOTAL_REVENUE]: {
			customerName: 'string',
			ccId: 'string',
			hyperAccountNumber: 'string',
			totalPaymentFeesAmountNis: 'custom',
			totalConversionFeesAmountNis: 'custom',
			totalPlanFeesNis: 'custom',
			totalRevenue: 'custom',
			accountCreationDate: 'string',
			lastLoginDate: 'string',
			lastLoginUser: 'string',
			lastActivityTimestamp: 'string',
			lastActivityType: 'string',
		},
		[DashboardCategories.PLAN]: {
			createdAt: 'date',
			customerName: 'string',
		},
	};
};
